import type { Usage } from '../../gql';

import { randNumber, randUuid } from '@ngneat/falso';

const mockUsageNames = [
    'Closure',
    'Labels',
    'Lining',
    'Padding',
    'Shell',
    'Trim Fabric',
    'Trim',
];

export const mockUsage = (overwrite?: Partial<Usage>): Usage => ({
    usagePublicId: randUuid(),
    usageName: mockUsageNames[randNumber({ max: 6 })],
    displayOrder: randNumber({ min: 1, max: 100 }),
    ...overwrite,
    ['__typename']: 'Usage',
});
